export interface IStaticLinks {
  social: { facebook: string; linkedin: string };
  trustpilot: {
    /** Public review page (www). */
    reviewPage: string;
    /** Same page on the Swedish subdomain (structured data, email signature). */
    reviewPageSe: string;
    /** "Write a review" page. */
    writeReview: string;
  };
  maps: {
    /** Stockholm office (krea.se, customer apps footer). */
    stockholm: string;
    /** Stockholm headquarters as listed on kredita.fi (postal code 114 47). */
    stockholmHeadquarters: string;
    /** Espoo office. */
    espoo: string;
  };
}

/** Static, environment-independent public links. */
export const LINKS: IStaticLinks = {
  social: {
    facebook: "https://www.facebook.com/kreaforetagslan/",
    linkedin: "https://www.linkedin.com/company/krea-se",
  },
  trustpilot: {
    reviewPage: "https://www.trustpilot.com/review/krea.se",
    reviewPageSe: "https://se.trustpilot.com/review/krea.se",
    writeReview: "https://www.trustpilot.com/evaluate/krea.se",
  },
  maps: {
    stockholm:
      "https://maps.google.com/?q=KREA%20F%C3%B6retagsl%C3%A5n%20Valhallav%C3%A4gen%2060,%20114%2027%20Stockholm",
    stockholmHeadquarters:
      "https://maps.google.com/?q=KREA%20F%C3%B6retagsl%C3%A5n%20Valhallav%C3%A4gen%2060,%20114%2047%20Stockholm",
    espoo:
      "https://www.google.com/maps/place/Wonderland+Work+Lepp%C3%A4vaara/@60.2117072,24.8134392,17z/data=!4m15!1m8!3m7!1s0x468df5d7e2cae661:0x98e466774ad35947!2sLinnoitustie+6,+02600+Espoo,+Finland!3b1!8m2!3d60.2117072!4d24.8134392!16s%2Fg%2F11c88dc9hv!3m5!1s0x468df5bf2d23861b:0x8d3c916b48882443!8m2!3d60.2119617!4d24.8147542!16s%2Fg%2F11ng59wsqy",
  },
};
